import PropTypes from 'prop-types';

import Link from 'bloko/blocks/link';

const EmployerLink = ({ employerId }) => {
    if (employerId === 0) {
        return null;
    }
    return (
        <Link href={`https://hh.ru/employer/${employerId}`} target="_blank">
            {employerId}
        </Link>
    );
};

EmployerLink.propTypes = {
    employerId: PropTypes.number,
};

export default EmployerLink;
